@if (variant === "counter") {
  <span
    [class]="{
      'on-color': color === 'on-color',
      info: color === 'info',
      error: color === 'error',
      empty: color === 'empty',
      turquoise: color === 'turquoise',
      'sky-blue': color === 'sky-blue',
      small: size === 'small',
      medium: size === 'medium',
      large: size === 'large',
      'sg-ui-component': true,
    }"
    [matBadge]="strBadge"></span>
} @else {
  <span
    class="dot-badge"
    [class]="{
      'on-color': color === 'on-color',
      info: color === 'info',
      error: color === 'error',
      empty: color === 'empty',
      turquoise: color === 'turquoise',
      'sky-blue': color === 'sky-blue',
      small: size === 'small',
      medium: size === 'medium',
      large: size === 'large',
    }"></span>
}
